import React from 'react';
import './Pages.css';

const StudentPortal = () => {
  return (
    <div className="page">
      <section className="page-header">
        <div className="container">
          <div className="page-title">Student Portal</div>
          <div className="page-subtitle">Zugang zu Ihren gebuchten Kursen</div>
        </div>
      </section>
      
      <section className="content-section">
        <div className="container">
          <div style={{ padding: '2rem', background: '#f8f9fa', borderRadius: '8px', textAlign: 'center' }}>
            <h3>Student Portal</h3>
            <p>Student interface will be implemented here</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StudentPortal;
